import React from 'react';
import { Routes } from 'react-router-dom';
import { publicRoutes } from './routes/publicRoutes';
import { dashboardRoutes } from './routes/dashboardRoutes';
import { adminRoutes } from './routes/adminRoutes';

function App() {
  return (
    <Routes>
      {publicRoutes}
      {dashboardRoutes}
      {adminRoutes}
    </Routes>
  );
}

export default App;